























import { SupportVueGB } from "@/extensions/support/SupportVueGB";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";
import BackLink from "@/components/app/BackLink.vue";

@Component({
  components: { VerifyBox, BackLink },
})
export default class ConnectionBankModal extends SupportVueGB {
}
